<template>
  <div
    v-if="loading"
    class="FullScreenLoading"
  >
    <div class="text-xs-center">
      <v-progress-circular
        indeterminate
        color="white"
        size="40"
      />
      <div class="white--text title mt-4">
        {{ text }}
        <!-- Loading... -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FullScreenLoading',
  data () {
    return {
      loading: false,
      text: '',
      bodyEl: null,
      originalEl: null
    }
  },
  mounted () {
    // 创建一个元素挂载到 body
    this.bodyEl = document.createElement('div')
    document.body.appendChild(this.bodyEl)
  },
  beforeDestroy () {
    // 组件销毁时移除挂载的元素
    if (this.bodyEl && this.bodyEl.parentNode) {
      this.bodyEl.parentNode.removeChild(this.bodyEl)
    }
    // 移除原始元素的引用
    this.originalEl = null
    this.bodyEl = null
  },
  methods: {
    show (text = '') {
      this.text = text
      this.loading = true
      this.$nextTick(() => {
        // 在下一个 tick 中，将组件内容移到 body 下
        this.originalEl = this.$el
        if (this.bodyEl && this.originalEl) {
          this.bodyEl.appendChild(this.originalEl)
        }
      })
    },
    hide () {
      this.loading = false
    }
  }
}
</script>
<style lang="postcss" scoped>
.FullScreenLoading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 9999999;
}
</style>
